var isFunction;

isFunction = require("./_helpers").isFunction;

module.exports = {
  _name: "if",
  _v: 1,
  methods: {
    $if: function(arg) {
      var anchor, append, els, els2, elseTemplate, remove, template, value;
      anchor = arg.anchor, els = arg.els, template = arg.template, value = arg.value, elseTemplate = arg.elseTemplate;
      if(process.env.NODE_ENV!=='production' && !value){throw new Error('no value provided for $if')};
      if (isFunction(els)) {
        template = els;
      }
      if (template) {
        els = null;
      }
      append = function(els) {
        var el, i, len, parent, results;
        parent = anchor.parentElement;
        results = [];
        for (i = 0, len = els.length; i < len; i++) {
          el = els[i];
          if (el.parentElement !== parent) {
            results.push(parent.insertBefore(el, anchor));
          } else {
            results.push(void 0);
          }
        }
        return results;
      };
      remove = function(els) {
        var el, i, len, results;
        results = [];
        for (i = 0, len = els.length; i < len; i++) {
          el = els[i];
          results.push(el.remove());
        }
        return results;
      };
      els2 = null;
      return this.$computed.orWatch(value, function(value, oldVal) {
        if (value) {
          if (template != null) {
            els = this.$path.resolveValue(template).call(this);
            template = null;
          }
          if (els) {
            append(els);
          }
          if (els2) {
            return remove(els2);
          }
        } else {
          if (elseTemplate != null) {
            els2 = this.$path.resolveValue(elseTemplate).call(this);
            elseTemplate = null;
          }
          if (els2) {
            append(els2);
          }
          if (els) {
            return remove(els);
          }
        }
      });
    }
  }
};

;



//////////////////
// WEBPACK FOOTER
// /home/peaul/ceri/ceri/lib/if.js
// module id = 48
// module chunks = 1